import { render } from "./SpConnectRegistrationHeader.vue?vue&type=template&id=1d807465&scoped=true&ts=true"
import script from "./SpConnectRegistrationHeader.vue?vue&type=script&lang=ts"
export * from "./SpConnectRegistrationHeader.vue?vue&type=script&lang=ts"

import "../../components/Header/RegistrationHeader.scss?vue&type=style&index=0&id=1d807465&lang=scss&scoped=true&external"
import "./SpConnectRegistrationHeader.vue?vue&type=style&index=1&id=1d807465&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d807465"]])

export default __exports__